module.exports = __webpack_public_path__ + "img/Loading.c4f4cd68.gif";